
import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'

export default function reportForm() {

  const owners = ref([])

  const contracts=ref([]);
  const contracts_orig=ref([])

  ReportService.getCategoriesFilterBy({
    type: 'plan',
    planType:'containerPest'
  }).then(response => { 
    owners.value = response.data.owners
    contracts.value = response.data.contracts
    contracts_orig.value=JSON.parse(JSON.stringify(response.data.contracts))
  })
 
  return {  
    owners,
    contracts,
    contracts_orig
  }
}
